import { ApiHelper } from '../apiHelper';
import { HttpClient } from '@angular/common/http';
import { UserDao } from './userDao';
import { RoleDao } from './roleDao';
import { TriggerDao } from './triggerDao';
import { AdvertiserDao } from './advertiserDao';
import { BrandDao } from './brandDao';
import { ActionDao } from './actionDao';
import { DeprecatedChannelDao } from './deprecatedChannelDao';
import { AgencyDao } from './agencyDao';
import { FailedMutationDao } from './failedMutationDao';
import { InviteDao } from './inviteDao';
import { IntegrationDao } from './integrationDao';
import { TraaqrTagDao } from './traaqrTagDao';
import { ReportDao } from './reportDao';
import { GoogleActionDao } from './googleActionDao';
import { FacebookActionDao } from './facebookActionDao';
import { AmazonActionDao } from './amazonActionDao';
import { TwitterActionDao } from './twitterActionDao';
import { SnapchatActionDao } from './snapchatActionDao';
import { IntegrationInviteDao } from './integrationInviteDao';
import { BcProductDao } from './bcProductDao';
import { ScheduledReportDao } from './scheduledReportDao';
import { CustomTriggerProviderDao } from './customTriggerProviderDao';
import { StationDao } from './stationDao';
import { VidVitaChannelDao } from './vidvitaChannelDao';
import { GoalDao } from './goalDao';
import { CustomReportDao } from './customReportDao';
import { BingActionDao } from './bingActionDao';
import { TradeDeskActionDao } from './tradeDeskActionDao';
import { RedshiftDao } from './redshiftDao';
import { DBPediaDao } from './dbPediaDao';
import { GoogleAnalyticsDao } from './googleAnalyticsDao';
import { PaymentDao } from './paymentDao';
import { PostlogConfigurationDao } from "./postlogConfigurationDao";
import { PostlogDao } from "./postlogDao";
import { PostlogProviderDao } from "./postlogProviderDao";
import {BidDataDao} from "./bidDataDao";
import {KeywordsDao} from "./keywordsDao";
import {GclidDao} from "./gclidDao";
import {LeadSourceDao} from "./leadSourceDao";
import {MasterChannelDao} from "./masterChannelDao";
import {MonitoredChannelDao} from "./monitoredChannelDao";
import { ChannelClusterDao } from './channelClusterDao';
import {DmaDao} from "./dmaDao";
import { MarketGroupDao } from './marketGroupDao';
import {AthenaDao} from "./athenaDao";
import {BigQueryDAO} from './bigQueryDAO';
import {AvsDao} from "./avsDao";
import { LookerDao } from './lookerDao';
import {SingletonDao} from "./singletonDao";
import { BuyScheduleAuditDao } from './buyScheduleAuditDao';
import { BuyScheduleDao } from './buyScheduleDao';
import { StationContactsByUserDao } from './stationContactsByUserDao';
import { BuyScheduleChangeRequestDao } from './buyScheduleChangeRequestDao';
import {ChannelMappingDao} from "./channelMappingDao";
import {ChannelMappingProviderDao} from "./channelMappingProviderDao";
import { ScheduleAnalyticsDao } from "./scheduleAnalyticsDao";
import {ScheduleIngestConfigDao} from "./scheduleIngestConfigDao";
import {MatchingBackfillDao} from "./matchingBackfillDao";
import {CustomerDao} from "./avs/customerDao";
import {FormatDao} from "./avs/formatDao";
import {EncoderGroupDao} from "./avs/encoderGroupDao";
import {ProfileDao} from "./avs/profileDao";
import {EncodingDao} from "./avs/encodingDao";
import { LookerDashboardMetadataDAO } from './lookerDashboardMetadataDAO';
import {ChannelDao} from "./channelDao";
import {MarketDao} from "./marketDao";
import { AvsMarketDao } from './avsMarketDao';
import { AvsMediaDao } from './avsMediaDao';
import { AvsBroadcasterDao } from './avsBroadcasterDao';
import { FormatBroadcasterFilterDao } from './FormatBroadcasterFilterDao';

/* INSERT DAO IMPORT */

/**
 * Master Dao Factories
 * These are autogenerate by gulp command
 * Do not modify the INSERT DAO IMPORT or the INSERT MASTER DAO FACTORY comments!!!
 */

export function masterUserDaoFactory(apiHelper: ApiHelper) {
  return new UserDao(apiHelper);
}
export function masterRoleDaoFactory(apiHelper: ApiHelper) {
  return new RoleDao(apiHelper);
}
export function masterTriggerDaoFactory(apiHelper: ApiHelper) {
  return new TriggerDao(apiHelper);
}
export function masterAdvertiserDaoFactory(apiHelper: ApiHelper) {
  return new AdvertiserDao(apiHelper);
}
export function masterBrandDaoFactory(apiHelper: ApiHelper) {
  return new BrandDao(apiHelper);
}
export function masterActionDaoFactory(apiHelper: ApiHelper) {
  return new ActionDao(apiHelper);
}
export function masterDeprecatedChannelDaoFactory(apiHelper: ApiHelper) {
  return new DeprecatedChannelDao(apiHelper);
}
export function masterAgencyDaoFactory(apiHelper: ApiHelper) {
  return new AgencyDao(apiHelper);
}
export function masterFailedMutationDaoFactory(apiHelper: ApiHelper) {
  return new FailedMutationDao(apiHelper);
}
export function masterInviteDaoFactory(apiHelper: ApiHelper) {
  return new InviteDao(apiHelper);
}
export function masterIntegrationDaoFactory(apiHelper: ApiHelper) {
  return new IntegrationDao(apiHelper);
}
export function masterTraaqrTagDaoFactory(apiHelper: ApiHelper) {
  return new TraaqrTagDao(apiHelper);
}
export function masterReportDaoFactory(apiHelper: ApiHelper) {
  return new ReportDao(apiHelper);
}
export function masterGoogleActionDaoFactory(apiHelper: ApiHelper) {
  return new GoogleActionDao(apiHelper);
}
export function masterFacebookActionDaoFactory(apiHelper: ApiHelper) {
  return new FacebookActionDao(apiHelper);
}
export function masterAmazonActionDaoFactory(apiHelper: ApiHelper) {
  return new AmazonActionDao(apiHelper);
}
export function masterTwitterActionDaoFactory(apiHelper: ApiHelper) {
  return new TwitterActionDao(apiHelper);
}
export function masterSnapchatActionDaoFactory(apiHelper: ApiHelper) {
  return new SnapchatActionDao(apiHelper);
}
export function masterIntegrationInviteDaoFactory(apiHelper: ApiHelper) {
  return new IntegrationInviteDao(apiHelper);
}
export function masterBcProoductDaoFactory(apiHelper: ApiHelper) {
  return new BcProductDao(apiHelper);
}
export function masterScheduledReportDaoFactory(apiHelper: ApiHelper) {
  return new ScheduledReportDao(apiHelper);
}
export function masterCustomTriggerProviderDaoFactory(apiHelper: ApiHelper) {
  return new CustomTriggerProviderDao(apiHelper);
}
export function masterStationDaoFactory(apiHelper: ApiHelper) {
  return new StationDao(apiHelper);
}
export function masterVidVitaChannelDaoFactory(apiHelper: ApiHelper) {
  return new VidVitaChannelDao(apiHelper);
}
export function masterGoalDaoFactory(apiHelper: ApiHelper) {
  return new GoalDao(apiHelper);
}
export function masterCustomReportDaoFactory(apiHelper: ApiHelper) {
  return new CustomReportDao(apiHelper);
}
export function masterBingActionDaoFactory(apiHelper: ApiHelper) {
  return new BingActionDao(apiHelper);
}
export function masterTradeDeskActionDaoFactory(apiHelper: ApiHelper) {
  return new TradeDeskActionDao(apiHelper);
}
export function masterRedshiftDaoFactory(apiHelper: ApiHelper) {
  return new RedshiftDao(apiHelper);
}
export function masterGoogleAnalyticsDaoFactory(apiHelper: ApiHelper) {
  return new GoogleAnalyticsDao(apiHelper);
}
export function masterDBPediaDaoFactory(apiHelper: ApiHelper) {
  return new DBPediaDao(apiHelper);
}
export function masterPaymentDaoFactory(apiHelper: ApiHelper) {
  return new PaymentDao(apiHelper);
}
export function masterPostlogConfigurationDaoFactory(apiHelper: ApiHelper) {
  return new PostlogConfigurationDao(apiHelper);
}
export function masterPostlogDaoFactory(apiHelper: ApiHelper) {
  return new PostlogDao(apiHelper);
}
export function masterPostlogProviderDaoFactory(apiHelper: ApiHelper) {
  return new PostlogProviderDao(apiHelper);
}
export function masterBidDataDaoFactory(apiHelper: ApiHelper) {
  return new BidDataDao(apiHelper);
}
export function masterKeywordsDaoFactory(apiHelper: ApiHelper) {
  return new KeywordsDao(apiHelper);
}
export function masterGClidDaoFactory(apiHelper: ApiHelper) {
  return new GclidDao(apiHelper);
}
export function masterLeadSourceDaoFactory(apiHelper: ApiHelper) {
  return new LeadSourceDao(apiHelper);
}

export function masterMasterChanneDaoFactory(apiHelper: ApiHelper) {
  return new MasterChannelDao(apiHelper);
}

export function masterMonitoredChannelDaoFactory(apiHelper: ApiHelper, httpClient: HttpClient) {
  return new MonitoredChannelDao(apiHelper, httpClient);
}

export function masterChannelClusterFactory(apiHelper: ApiHelper) {
  return new ChannelClusterDao(apiHelper);
}

export function masterDmaDaoFactory(apiHelper: ApiHelper) {
  return new DmaDao(apiHelper);
}

export function masterMarketGroupFactory(apiHelper: ApiHelper) {
  return new MarketGroupDao(apiHelper);
}

export function masterAthenaDaoFactory(apiHelper: ApiHelper) {
  return new AthenaDao(apiHelper);
}

export function masterBigQueryDaoFactory(apiHelper: ApiHelper) {
  return new BigQueryDAO(apiHelper);
}

export function masterAvsDaoFactory(apiHelper: ApiHelper) {
  return new AvsDao(apiHelper);
}

export function masterLookerDaoFactory(apiHelper: ApiHelper) {
  return new LookerDao(apiHelper);
}

export function masterBuyScheduleAuditDaoFactory(apiHelper: ApiHelper) {
  return new BuyScheduleAuditDao(apiHelper);
}

export function masterBuyScheduleDaoFactory(apiHelper: ApiHelper) {
  return new BuyScheduleDao(apiHelper);
}

export function masterSingletonDaoFactory(apiHelper: ApiHelper) {
  return new SingletonDao(apiHelper);
}

export function masterStationContactsByUserDaoFactory(apiHelper: ApiHelper) {
  return new StationContactsByUserDao(apiHelper);
}

export function masterBuyScheduleChangeRequestDaoFactory(apiHelper: ApiHelper) {
  return new BuyScheduleChangeRequestDao(apiHelper);
}

export function masterChannelMappingDaoFactory(apiHelper: ApiHelper) {
  return new ChannelMappingDao(apiHelper);
}

export function masterChannelMappingProviderDaoFactory(apiHelper: ApiHelper) {
  return new ChannelMappingProviderDao(apiHelper);
}

export function masterScheduleAnalyticsDaoFactory(apiHelper: ApiHelper) {
  return new ScheduleAnalyticsDao(apiHelper);
}

export function masterScheduleIngestConfigDaoFactory(apiHelper: ApiHelper) {
  return new ScheduleIngestConfigDao(apiHelper);
}

export function masterMatchingBackfillDaoFactory(apiHelper: ApiHelper) {
  return new MatchingBackfillDao(apiHelper);
}

export function masterCustomerDaoFactory(apiHelper: ApiHelper) {
  return new CustomerDao(apiHelper);
}

export function masterFormatDaoFactory(apiHelper: ApiHelper) {
  return new FormatDao(apiHelper);
}

export function masterEncoderGroupDaoFactory(apiHelper: ApiHelper) {
  return new EncoderGroupDao(apiHelper);
}

export function masterProfileDaoFactory(apiHelper: ApiHelper) {
  return new ProfileDao(apiHelper);
}

export function masterEncodingDaoFactory(apiHelper: ApiHelper) {
  return new EncodingDao(apiHelper);
}

export function masterLookerDashboardMetadataDAO(apiHelper: ApiHelper) {
  return new LookerDashboardMetadataDAO(apiHelper);
}

export function masterChannelDaoFactory(apiHelper: ApiHelper) {
  return new ChannelDao(apiHelper);
}

export function masterMarketDaoFactory(apiHelper: ApiHelper) {
  return new MarketDao(apiHelper);
}

export function masterAvsMarketDaoFactory(apiHelper: ApiHelper) {
  return new AvsMarketDao(apiHelper);
}

export function masterAvsMediaDaoFactory(apiHelper: ApiHelper) {
  return new AvsMediaDao(apiHelper);
}

export function masterAvsBroadcasterDaoFactory(apiHelper: ApiHelper) {
  return new AvsBroadcasterDao(apiHelper);
}

export function masterFormatBroadcasterFilterDaoFactory(apiHelper: ApiHelper) {
  return new FormatBroadcasterFilterDao(apiHelper);
}
/* INSERT MASTER DAO FACTORY */

/**
 * Other Dao Factories
 * Add these yourself, just don't intermingle with the auto generated Master Factories
 */

/**
 * Master Dao Providers
 * These are autogenerate by gulp command
 * Do not modify the INSERT MASTER DAO PROVIDER comment!!!
 */

export function provideMasterUserDao() {
  return {
    provide: UserDao,
    useFactory: masterUserDaoFactory,
    deps: [ApiHelper]
  };
}

export function provideMasterRoleDao() {
  return {
    provide: RoleDao,
    useFactory: masterRoleDaoFactory,
    deps: [ApiHelper]
  };
}

export function provideMasterTriggerDao() {
  return {
    provide: TriggerDao,
    useFactory: masterTriggerDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterAdvertiserDao() {
  return {
    provide: AdvertiserDao,
    useFactory: masterAdvertiserDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterBrandDao() {
  return {
    provide: BrandDao,
    useFactory: masterBrandDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterActionDao() {
  return {
    provide: ActionDao,
    useFactory: masterActionDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterDeprecatedChannelDao() {
  return {
    provide: DeprecatedChannelDao,
    useFactory: masterDeprecatedChannelDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterAgencyDao() {
  return {
    provide: AgencyDao,
    useFactory: masterAgencyDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterFailedMutationDao() {
  return {
    provide: FailedMutationDao,
    useFactory: masterFailedMutationDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterInviteDao() {
  return {
    provide: InviteDao,
    useFactory: masterInviteDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterIntegrationDao() {
  return {
    provide: IntegrationDao,
    useFactory: masterIntegrationDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterTraaqrTagDao() {
  return {
    provide: TraaqrTagDao,
    useFactory: masterTraaqrTagDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterReportDao() {
  return {
    provide: ReportDao,
    useFactory: masterReportDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterGoogleActionDao() {
  return {
    provide: GoogleActionDao,
    useFactory: masterGoogleActionDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterFacebookActionDao() {
  return {
    provide: FacebookActionDao,
    useFactory: masterFacebookActionDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterAmazonActionDao() {
  return {
    provide: AmazonActionDao,
    useFactory: masterAmazonActionDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterTwitterActionDao() {
  return {
    provide: TwitterActionDao,
    useFactory: masterTwitterActionDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterSnapchatActionDao() {
  return {
    provide: SnapchatActionDao,
    useFactory: masterSnapchatActionDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterIntegrationInviteDao() {
  return {
    provide: IntegrationInviteDao,
    useFactory: masterIntegrationInviteDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterBcProductDao() {
  return {
    provide: BcProductDao,
    useFactory: masterBcProoductDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterScheduledReportDao() {
  return {
    provide: ScheduledReportDao,
    useFactory: masterScheduledReportDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterCustomTriggerProviderDao() {
  return {
    provide: CustomTriggerProviderDao,
    useFactory: masterCustomTriggerProviderDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterStationDao() {
  return {
    provide: StationDao,
    useFactory: masterStationDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterVidVitaDao() {
  return {
    provide: VidVitaChannelDao,
    useFactory: masterVidVitaChannelDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterGoalDao() {
  return {
    provide: GoalDao,
    useFactory: masterGoalDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterCustomReportDao() {
  return {
    provide: CustomReportDao,
    useFactory: masterCustomReportDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterBingActionDao() {
  return {
    provide: BingActionDao,
    useFactory: masterBingActionDaoFactory,
    deps: [ApiHelper]
  };
}

export function provideMasterTradeDeskActionDao() {
  return {
    provide: TradeDeskActionDao,
    useFactory: masterTradeDeskActionDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterRedshiftDao() {
  return {
    provide: RedshiftDao,
    useFactory: masterRedshiftDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterGoogleAnalyticsDao() {
  return {
    provide: GoogleAnalyticsDao,
    useFactory: masterGoogleAnalyticsDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterDBPediaDao() {
  return {
    provide: DBPediaDao,
    useFactory: masterDBPediaDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterPaymentDao() {
  return {
    provide: PaymentDao,
    useFactory: masterPaymentDaoFactory,
    deps: [ApiHelper]
  };
}
export function provideMasterPostlogConfigurationDao() {
  return {
    provide: PostlogConfigurationDao,
    useFactory: masterPostlogConfigurationDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterPostlogDao() {
  return {
    provide: PostlogDao,
    useFactory: masterPostlogDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterPostlogProviderDao() {
  return {
    provide: PostlogProviderDao,
    useFactory: masterPostlogProviderDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterBidDataDao() {
  return {
    provide: BidDataDao,
    useFactory: masterBidDataDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterKeywordsDao() {
  return {
    provide: KeywordsDao,
    useFactory: masterKeywordsDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterGclidDao() {
  return {
    provide: GclidDao,
    useFactory: masterGClidDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterLeadSourceDao() {
  return {
    provide: LeadSourceDao,
    useFactory: masterLeadSourceDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterMasterChannelDao() {
  return {
    provide: MasterChannelDao,
    useFactory: masterMasterChanneDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterMonitoredChannelDao() {
  return {
    provide: MonitoredChannelDao,
    useFactory: masterMonitoredChannelDaoFactory,
    deps: [ApiHelper, HttpClient]
  }
}
export function provideMasterChannelClusterDao() {
  return {
    provide: ChannelClusterDao,
    useFactory: masterChannelClusterFactory,
    deps: [ApiHelper]
  }
}
export function provideMasterDmaDao() {
  return {
    provide: DmaDao,
    useFactory: masterDmaDaoFactory,
    deps: [ApiHelper]
  }
}
export function provideMarketGroupDao() {
  return {
    provide: MarketGroupDao,
    useFactory: masterMarketGroupFactory,
    deps: [ApiHelper]
  }
}

export function provideAthenaDao() {
  return {
    provide: AthenaDao,
    useFactory: masterAthenaDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideBigQueryDao() {
  return {
    provide: BigQueryDAO,
    useFactory: masterBigQueryDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideAvsDao() {
  return {
    provide: AvsDao,
    useFactory: masterAvsDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideLookerDao() {
  return {
    provide: LookerDao,
    useFactory: masterLookerDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideBuyScheduleAuditDao() {
  return {
    provide: BuyScheduleAuditDao,
    useFactory: masterBuyScheduleAuditDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideBuyScheduleDao() {
  return {
    provide: BuyScheduleDao,
    useFactory: masterBuyScheduleDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideSingletonDao() {
  return {
    provide: SingletonDao,
    useFactory: masterSingletonDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideStationContactsByUserDao() {
  return {
    provide: StationContactsByUserDao,
    useFactory: masterStationContactsByUserDaoFactory,
    deps: [ApiHelper]
  }
}


export function provideBuyScheduleChangeRequestDao() {
  return {
    provide: BuyScheduleChangeRequestDao,
    useFactory: masterBuyScheduleChangeRequestDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideChannelMappingDao() {
  return {
    provide: ChannelMappingDao,
    useFactory: masterChannelMappingDaoFactory,
    deps: [ApiHelper]
  }
}


export function provideChannelMappingProviderDao() {
  return {
    provide: ChannelMappingProviderDao,
    useFactory: masterChannelMappingProviderDaoFactory,
    deps: [ApiHelper]
  }
}


export function provideScheduleAnalyticsDao() {
  return {
    provide: ScheduleAnalyticsDao,
    useFactory: masterScheduleAnalyticsDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideScheduleIngestConfigDao() {
  return {
    provide: ScheduleIngestConfigDao,
    useFactory: masterScheduleIngestConfigDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideMatchingBackfillDao() {
  return {
    provide: MatchingBackfillDao,
    useFactory: masterMatchingBackfillDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideCustomerDao() {
  return {
    provide: CustomerDao,
    useFactory: masterCustomerDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideFormatDao() {
  return {
    provide: FormatDao,
    useFactory: masterFormatDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideEncoderGroupDao() {
  return {
    provide: EncoderGroupDao,
    useFactory: masterEncoderGroupDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideProfileDao() {
  return {
    provide: ProfileDao,
    useFactory: masterProfileDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideEncodingDao() {
  return {
    provide: EncodingDao,
    useFactory: masterEncodingDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideLookerDashboardMetadataDao() {
  return {
    provide: LookerDashboardMetadataDAO,
    useFactory: masterLookerDashboardMetadataDAO,
    deps: [ApiHelper]
  }
}

export function provideMasterChannelDao() {
  return {
    provide: ChannelDao,
    useFactory: masterChannelDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideMasterMarketDao() {
  return {
    provide: MarketDao,
    useFactory: masterMarketDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideMasterAvsMarketDao() {
  return {
    provide: AvsMarketDao,
    useFactory: masterAvsMarketDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideMasterAvsMediaDao() {
  return {
    provide: AvsMediaDao,
    useFactory: masterAvsMediaDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideMasterAvsBroadcasterDao() {
  return {
    provide: AvsBroadcasterDao,
    useFactory: masterAvsBroadcasterDaoFactory,
    deps: [ApiHelper]
  }
}

export function provideMasterFormatBroadcasterFilterDao() {
  return {
    provide: FormatBroadcasterFilterDao,
    useFactory: masterFormatBroadcasterFilterDaoFactory,
    deps: [ApiHelper]
  }
}
/* INSERT MASTER DAO PROVIDER */

/**
 * Other Dao Providers
 * Add these yourself, just don't intermingle with the auto generated Master Providers
 */
